import { useEffect, useState } from "react";
import { Video } from "lucide-react";
import api from "@/lib/api";

/* Guide Workspace — Zoom attendance of the Guide's assigned participants (read-only; opened by the Organizer + 'view_attendance' permission). */
export const GuideAttendance = () => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/guide/zoom/attendance").then(({ data }) => setD(data)).catch((e) => setErr(e.response?.data?.detail || "Could not load attendance")); }, []);
  if (err) return <p className="text-xs text-rose-700" data-testid="guide-attendance-error">{err}</p>;
  if (!d) return <p className="text-xs text-[#1A2E26]/60">Loading…</p>;
  const sessions = d.sessions.slice(0, 8);
  const people = {};
  d.rows.forEach((r) => { const p = people[r.participant_id] ||= { name: r.name, mobile: r.mobile, by: {} }; p.by[r.session_uuid] = r; });
  const list = Object.values(people).sort((a, b) => a.name.localeCompare(b.name));
  if (!list.length) return <p className="text-xs text-[#1A2E26]/60" data-testid="guide-attendance-empty">No Zoom attendance recorded yet for your participants.</p>;
  return (
    <div className="overflow-x-auto" data-testid="guide-attendance">
      <table className="w-full text-[11px]">
        <thead><tr className="text-left text-[10px] uppercase tracking-wider text-[#1A2E26]/55 border-b"><th className="py-1 pr-2">Participant</th>{sessions.map((s) => <th key={s.uuid} className="pr-2 whitespace-nowrap" title={s.label}><span className="inline-flex items-center gap-1"><Video size={10} /> {s.date.slice(5)}{s.day ? ` D${s.day}` : ""} {s.kind === "guides" ? "· eve" : ""}</span></th>)}</tr></thead>
        <tbody>{list.map((p, i) => (
          <tr key={p.name + i} data-testid={`guide-attendance-row-${i}`} className="border-b border-[#1A2E26]/8">
            <td className="py-1 pr-2 font-medium whitespace-nowrap">{p.name}{p.mobile ? <span className="text-[#1A2E26]/50"> · {p.mobile.slice(-4)}</span> : ""}</td>
            {sessions.map((s) => { const r = p.by[s.uuid]; return <td key={s.uuid} className="pr-2">{r ? <span className={`rounded-full px-1.5 py-px font-semibold ${r.present ? "bg-emerald-100 text-emerald-800" : "bg-rose-100 text-rose-800"}`}>{r.pct}%</span> : <span className="text-[#1A2E26]/35">absent</span>}</td>; })}
          </tr>))}</tbody>
      </table>
    </div>
  );
};
